// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "sPlant_Rate"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [{
    key: "id",
    label: "编号",
    sortable: true,
    thStyle: {
      width: "60px"
    }
  },
  {
    key: "SEI_Name",
    label: "供应商名称",
    sortable: true,
    thStyle: {
      width: "20rem"
    }
  },
  {
    key: "AccountNum",
    label: "供应商帐户",
    sortable: true
  },
  {
    key: "VendGroup",
    label: "组",
    sortable: true
  },
  {
    key: "PaymTermId",
    label: "付款期限",
    sortable: true
  },
  {
    key: "Currency",
    label: "币种",
    sortable: true
  },
  {
    key: "PaymMode",
    label: "付款方式",
    sortable: true
  },
  {
    key: "TaxGroup",
    label: "销售税组",
    sortable: true
  },
  {
    key: "InclTax",
    label: "价格包括销售税",
    sortable: true
  },
  {
    key: "PaymDayId",
    label: "付款日",
    sortable: true
  },
  {
    key: "Nationality_MX",
    label: "国籍",
    sortable: true
  },
  {
    key: "ServiceScore",
    label: "服务态度",
    sortable: true,
    type: "arr_rate",
    thStyle: {
      width: "10rem"
    }
  },
  {
    key: "QualityScore",
    label: "产品品质",
    sortable: true,
    type: "arr_rate",
    thStyle: {
      width: "10rem"
    }
  },
  {
    key: "ResponseScore",
    label: "响应速度",
    sortable: true,
    type: "arr_rate",
    thStyle: {
      width: "10rem"
    }
  },
  {
    key: "DeliveryScore",
    label: "交货及时率",
    sortable: true,
    type: "arr_rate",
    thStyle: {
      width: "10rem"
    }
  },
  {
    key: "TotalScore",
    label: "总分",
    sortable: true,
    type: "arr_rate",
    thStyle: {
      width: "10rem"
    },
    isTotalScore: true,
    disabled: true,
  },
  ]
}

const dataForm = {
  id: "",
  VendAccountNum: "",
  TotalScore: 0
}

///前端验证
const rules = {}

const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const methods = {
  ///get
  async getData(_params) {
    const vend_biz_data = new biz_data_helper.base_entity_helper(
      "SEI_VendTable", {}, {}
    )
    let _fields = _.map(fields.default, "key")
    _.remove(_fields, n => {
      return n == "TotalScore"
    })
    let _actions = []
    _actions.push(
      vend_biz_data
        .selectAction({
          params: _params,
          fields: _fields
        })
        .action({})
    )
    _actions.push(
      biz_data
        .selectAction({
          params: {
            is_deleted: {
              "=": 0
            }
          },
          fields: ["id", "VendAccountNum", "TotalScore", "QualityScore", "ServiceScore", "ResponseScore", "DeliveryScore"]
        })
        .action({})
    )
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  ///save
  async saveData(items) {
    if (items && items.length > 0) {
      _.each(items, t => {
        t.QualityScore = t.QualityScore * 5
        t.ServiceScore = t.ServiceScore * 5
        t.ResponseScore = t.ResponseScore * 5
        t.DeliveryScore = t.DeliveryScore * 5
        t.TotalScore = t.QualityScore + t.DeliveryScore + t.ResponseScore + t.ServiceScore
      })
    }
    let _actions = []
    _.each(items, t => {
      if (_.isInteger(t.id)) {
        _actions.push(
          biz_data
            .updateAction({
              params: t,
              fields: ["id"]
            })
            .action({})
        )
      } else {
        let _m = _.cloneDeep(t)
        delete _m.id
        _actions.push(
          biz_data
            .insertAction({
              params: _m,
              fields: ["id"]
            })
            .action({})
        )
      }
    })

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  }
}
export {
  biz_data, dataForm, fields, methods,
  rules
};

